import Switch from '@mui/material/Switch'
import React from 'react'
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'
import CheckIcon from '@mui/icons-material/Check'

/** @notExported  */
interface AllocationStateSwitchProps {
  /** Whether the switch is checked. */
  checked: boolean
  /** The switch change handler. */
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
  /** Optional test id. */
  testId?: string
}

/**
 * Allocation state switch.
 *
 * @returns Allocation state switch component.
 * @notExported
 */
const AllocationStateSwitch: React.FC<AllocationStateSwitchProps> = ({ checked, onChange, testId }) => {
  return (
    <Switch
      checked={checked}
      data-testid={testId ?? 'switch-allocation-state'}
      icon={
        <HourglassBottomIcon
          sx={{
            backgroundColor: theme => theme.palette.warning.main,
            borderRadius: '100%',
            padding: '2px',
            color: theme => theme.palette.background.paper,
          }}
          fontSize="small"
        />
      }
      checkedIcon={
        <CheckIcon
          sx={{
            backgroundColor: theme => theme.palette.success.main,
            borderRadius: '100%',
            padding: '2px',
            color: theme => theme.palette.background.paper,
          }}
          fontSize="small"
        />
      }
      slotProps={{ input: { 'aria-label': 'allocation state' } }}
      onChange={onChange}
    />
  )
}

export default AllocationStateSwitch
